import React, { useState, useEffect } from "react";
import ListUser from "../../styledComponents/Table/ListUser";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import SearchIcon from "../../../assets/images/DeathModuleNew/Search.png";
import DEATH_API from "../../../apis/death.api";
import { Modal, Select } from "antd";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import "../Permissions/permission.css";
import swal from "sweetalert";
const { Option } = Select;

export const ManagementMain = () => {
  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [updatedObject, setUpdateObject] = useState(null);
  const [roleModal, setRoleModal] = useState(false);
  const [userList, setUserList] = useState([]);
  const [formData, setFormData] = useState(null);
  const [roles, setRoles] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);

  const cols = [
    {
      title: "ID",
      dataIndex: "id",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "UserName",
      dataIndex: "userName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Role",
      dataIndex: "roleName",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Action",
      render: (record, index) => {
        return (
          <div key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}>
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setRoleModal(true);
                        setDropdown(false);
                      }}>
                      Update
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}{" "}
          </div>
        );
      },
    },
  ];

  const getUsersList = async () => {
    try {
      (async () => {
        setLoading(true);
        let data = await DEATH_API.getUsersList();
        let obj = [];
        setSearchTerm("");
        setFilteredData([]);
        setUserList([]);
        if (data && data.data) {
          console.log(" data.data.roles[0]", data.data);
          data.data.map((item, index) => {
            if (item.roles[0]) {
              let roleName = item.roles[0].name;
              obj.push({
                id: item.id,
                userName: item.userName,
                name: item.name,
                roleName: roleName,
              });
            }
          });
          //   console.log("objalll",obj)
          setUserList(obj);
        }
        setLoading(false);
      })();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getRolesList = async () => {
    try {
      (async () => {
        setLoading(true);

        let data = await DEATH_API.getRoles();
        if (data && data.data) {
          setRoles(data.data);
        }
        setLoading(false);
      })();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    console.log("calling api");
    getRolesList();
    getUsersList();
  }, []);
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
    let selectedRow = userList.filter((row, index) => {
      return row.id == id;
    });

    console.log("selectedRow", selectedRow[0]);
    setFormData(selectedRow[0]);
    setUpdateObject(selectedRow[0]);
  };
  const updateUserRole = async () => {
    setRoleModal(false);
    try {
      setLoading(true);
      let api_res = await DEATH_API.updateUserList(selectedIndex, {
        roleId: formData && formData.roleId,
      });
      setLoading(false);
      if (api_res && api_res.status === 400) {
        swal("Error", api_res.message, "error");
      }
      getUsersList();
    } catch (error) {
      console.log(error);
      setLoading(false);
      throw new Error(error);
    }
    setFormData(null);
    setUpdateObject(null);
  };
  const handleChange = (id, name) => {
    setFormData({
      ...formData,
      ["roleName"]: name,
      ["roleId"]: id,
    });
  };
  const handleCancel = () => {
    setRoleModal(false);
    setFormData(null);
    setUpdateObject(null);
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const handleSearch = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setSearchTerm(searchTerm);
    const filteredResults =
      userList &&
      userList.filter((item) => item.name.toLowerCase().includes(searchTerm));
    setFilteredData(filteredResults);
  };

  return (
    <div className="mainRole">
      <div className="rolesTable">
        <div className="RolesHeader">
          <div className="RoleTitle">User List</div>

          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                border: "1px solid #2a3da3",
                borderRadius: "5px",
                marginRight: "1rem",
                height: "2rem",
              }}>
              <img
                style={{ marginTop: "6px", marginLeft: "6px" }}
                width={"20px"}
                height={"20px"}
                src={SearchIcon}
                alt="search"></img>
              <input
                className="searchInput"
                type="text"
                name="search"
                placeholder="Search"
                value={searchTerm && searchTerm}
                onChange={handleSearch}></input>
            </div>
          </div>
        </div>
        <ListUser
          cols={cols}
          rows={
            filteredData && filteredData.length > 0 ? filteredData : userList
          }
          StatePage={(num) => setPageNumber(num)}
        />
        {console.log("pagenumber", pageNumber)}
      </div>
      {roleModal && (
        <Modal
          visible={roleModal}
          centered
          footer={null}
          // onOk={handleOk}
          // onCancel={handleCancel}
          closable={false}>
          <h3 className="modaltitle">Update User Role</h3>

          <h3 className="inputTitle">User Name</h3>
          <input
            className="roleInput"
            placeholder="Permission Name"
            name="name"
            id="Permission"
            disabled={true}
            value={formData && formData.name}
            style={{ opacity: "0.7", cursor: "not-allowed" }}
          />
          <h3 className="inputTitle">Role Name</h3>
          <Select
            showSearch
            placeholder="Select Role"
            listHeight="120"
            value={formData && formData.roleName}
            onChange={(id, value) => {
              handleChange(id, value.props.children);
              console.log("eeeeeeee", id, value.props.children);
            }}>
            {roles &&
              roles.map((item, index) => (
                <Option key={index} value={item.id}>
                  {item.name}
                </Option>
              ))}
          </Select>
          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancel();
              }}>
              Cancel
            </button>
            <button
              className="savebutton"
              onClick={() => {
                if (updatedObject) {
                  updateUserRole();
                }
              }}>
              Save
            </button>
          </div>
        </Modal>
      )}
      <NewLoader isLoading={loading} />
    </div>
  );
};
